import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetMatchLineUps } from '../../../sportradar-widgets/SrWidgetMatchLineUps';

function BetradarMTStatisticsMatchLineups({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper>
                <SrWidgetMatchLineUps matchId={matchId} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatisticsMatchLineups;
